<template>
    <b-card class="shadowed p-2 h-100">
        <h6 v-bind:class="[isDisabled ? 'text-disabled' : 'text-primary']">
            {{title}}
        </h6>
        <p v-bind:class="{ 'text-disabled': isDisabled }">
            {{description}}
        </p>
        <div class="row">
            <div class="col-7 align-items-center d-flex text-small">
                {{label}}
            </div>
            <div class="col-5">
                <div class="d-flex justify-content-end">
                    <b-button
                        :variant=buttonStatus
                        :href="this.link"
                        :target="targetBlank ? '_blank' : '_self'"
                        @click="trackMixpanelEvent()"
                        :disabled="isDisabled"
                    >{{buttonText}}</b-button>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
    export default {
        name: "TextCard",
        props: {
            title: String,
            description: String,
            buttonText: String,
            isDisabled: Boolean,
            status: String,
            link: String,
            label: String,
            trackEvent: String,
            targetBlank: Boolean
        },

        methods:{
            trackMixpanelEvent() {
                trackEvent(this.trackEvent, {});
            }
        },

        computed:{
            buttonStatus: function() {
                return this.isDisabled ? "disabled" : this.status === 'completed' ? 'outline-secondary' : 'secondary'
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
